<template>
    <div class="space-y-2">
        <h2 class="uppercase text-sm text-zinc-400">Hue</h2>    
        <div class="flex flex-col gap-y-8">
            <ItemConverter /> 
            <ItemDropdown
                label="Number of Hues"
                v-model="selectNumberOfHues"
                :options="[
                    {value: 6, label: '6'},
                    {value: 8, label: '8'},
                    {value: 10, label: '10'},
                    {value: 12, label: '12'},
                    {value: 14, label: '14'},
                ]"/>
            <ItemDropdown
                label="Split"
                v-model="selectSplitType"
                :options="[
                    {value: 'even', label: 'Even'},
                    {value: 'harmonic', label: 'Harmonic'},
                ]"
            />
        </div>
    </div>
</template>

<script>
import ItemConverter from './ItemConverter.vue'
import ItemDropdown from './ItemDropdown.vue'
import { store } from '../store.js'
import { computed } from 'vue'

export default {
    name: 'SectionHue',
    components: {
        ItemDropdown,
        ItemConverter
    },
    setup() {        
        const selectNumberOfHues = computed({
            get: () => store.numberOfHues,
            set: (value) => { store.setNumberOfHues(value) }
        })

        const selectSplitType = computed({
            get: () => store.splitType,
            set: (value) => {
                store.setSplitType(value)
            }
        })

        return {
            selectNumberOfHues,
            selectSplitType
        }
    }
}
</script>